import DomainChangeLog from './domainchangelog'

export default DomainChangeLog